import React, { Component } from "react";
import { bool, func, string, shape, oneOfType, number } from "prop-types";
import classNames from "classnames";
import I18n from "pages/_components/I18n";
import Image from "pages/_components/Image";
import FieldError from "pages/_components/fields/FieldError";

class Checkbox extends Component {
    static propTypes = {
        checked: bool,
        name: string,
        labelText: string,
        onChange: func,
        field: shape({
            onBlur: func,
            onChange: func,
            name: string,
            value: oneOfType([number, string]),
        }),
        idForm: string,
        form: shape({
            touched: shape({}),
            errors: shape({}),
        }),
        labelTextProps: shape({}),
        disabled: bool,
        hideLabel: bool,
        labelFromService: bool,
        labelClassName: string,
        aditionalI18nText: string,
    };

    static defaultProps = {
        onChange: () => {},
        checked: false,
        name: "",
        labelText: "",
        field: null,
        idForm: "",
        form: null,
        labelTextProps: {},
        disabled: false,
        hideLabel: false,
        labelFromService: false,
        labelClassName: "",
        aditionalI18nText: "",
    };

    render() {
        const {
            checked,
            onChange,
            name,
            labelText,
            field,
            form,
            idForm,
            labelTextProps,
            disabled,
            hideLabel,
            labelFromService,
            labelClassName,
            aditionalI18nText,
        } = this.props;
        const controlName = field ? field.name : name;
        let hasError = false;
        let error = "";
        if (form) {
            const { touched, errors } = form;
            hasError = touched[field.name] && errors[field.name];
            error = errors[field.name];
        }

        return (
            <div
                className={classNames("c-control", "c-control--has-icon", "c-control--checkbox", {
                    "has-error": hasError,
                })}>
                <input
                    id={`checkbox_${controlName}`}
                    className="c-control-input"
                    type="checkbox"
                    name={controlName}
                    checked={field ? field.value : checked}
                    disabled={disabled}
                    onChange={() => {
                        if (field && form) {
                            form.setFieldValue(field.name, !field.value);
                        }
                        onChange(field ? !field.value : !checked);
                    }}
                />
                <label className="c-control-label" htmlFor={`checkbox_${controlName}`}>
                    <div className="c-control-icons">
                        <div className="c-control-mark">
                            <Image src="images/check.svg" className="svg-icon svg-caret" />
                        </div>
                    </div>
                    {!hideLabel && !labelFromService && (
                        <div className={`c-control-text ${labelClassName}`}>
                            {labelText && <I18n id={labelText} {...labelTextProps} />}
                            {!labelText && field && <I18n id={`${idForm}.${field.name}.label`} />}
                            {aditionalI18nText && <I18n id={aditionalI18nText} />}
                        </div>
                    )}
                    {labelFromService && <div className={`c-control-text ${labelClassName}`}>{labelText}</div>}
                </label>

                {hasError && <FieldError error={error} />}
            </div>
        );
    }
}

export default Checkbox;
